export enum CardStatus {
  Created = "CREATED",
  Issued = "ISSUED",
  Active = "ACTIVE",
  Inactive = "INACTIVE",
  Removed = "REMOVED",
  None = "NONE"
}
